module.exports = __webpack_public_path__ + "img/gift.59bfdee9.svg";